function isNetworkError(xhr) {
  if (!xhr) {
    return false;
  }

  return xhr.readyState !== 0 && xhr.readyState !== 4 || xhr.status === 0;
}

module.exports = isNetworkError;


//////////////////
// WEBPACK FOOTER
// ./~/@uppy/utils/lib/isNetworkError.js
// module id = 367
// module chunks = 0